import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import TrustMarquee from "@/components/sections/TrustMarquee";
import Plans from "@/components/sections/Plans";
import Process from "@/components/sections/Process";
import Legacy from "@/components/sections/Legacy";
import Testimonials from "@/components/sections/Testimonials";
import LeadForm from "@/components/sections/LeadForm";
import FAQ from "@/components/sections/FAQ";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <div className="relative min-h-screen overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <TrustMarquee />
        <Plans />
        <Process />
        <Legacy />
        <Testimonials />
        <LeadForm />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
